"use strict";
var arc = require('./arc.svg');
var brace = require('./brace.svg');
var ellipse = require('./ellipse.svg');
var endoplasmicReticulum = require('./endoplasmic-reticulum.svg');
var hexagon = require('./hexagon.svg');
var golgiApparatus = require('./golgi-apparatus.svg');
var mimDegradation = require('./mim-degradation.svg');
var mitochondria = require('./mitochondria.svg');
var none = require('./none.svg');
var octagon = require('./octagon.svg');
var pentagon = require('./pentagon.svg');
var rectangle = require('./rectangle.svg');
var roundedRectangle = require('./rounded-rectangle.svg');
var sarcoplasmicReticulum = require('./sarcoplasmic-reticulum.svg');
var triangle = require('./triangle.svg');
// for more, see
// https://commons.wikimedia.org/wiki/Category:Icons
// https://github.com/wikipathways/pvjs/tree/609615339cfd2c3b862f4ccbff12ca4b56b35940/src/shape-library/symbols
var icons = {
    Arc: {
        id: 'arc',
        url: arc
    },
    Brace: {
        id: 'brace',
        url: brace
    },
    'Endoplasmic Reticulum': {
        id: 'endoplasmic-reticulum',
        url: endoplasmicReticulum
    },
    Hexagon: {
        id: 'hexagon',
        url: hexagon
    },
    'Golgi Apparatus': {
        id: 'golgi-apparatus',
        url: golgiApparatus
    },
    MimDegradation: {
        id: 'mim-degradation',
        url: mimDegradation
    },
    Mitochondria: {
        id: 'mitochondria',
        url: mitochondria
    },
    None: {
        id: 'none',
        url: none
    },
    Ellipse: {
        id: 'ellipse',
        url: ellipse
    },
    Octagon: {
        id: 'octagon',
        url: octagon
    },
    Pentagon: {
        id: 'pentagon',
        url: pentagon
    },
    Rectangle: {
        id: 'rectangle',
        url: rectangle,
    },
    RoundedRectangle: {
        id: 'rounded-rectangle',
        url: roundedRectangle,
    },
    'Sarcoplasmic Reticulum': {
        id: 'sarcoplasmic-reticulum',
        url: sarcoplasmicReticulum
    },
    Triangle: {
        id: 'triangle',
        url: triangle
    },
};
icons.Circle = icons.Oval = icons.Ellipse;
icons.Complex = icons.Octagon;
// if we allow for true none, it's hard to do custom styling
icons.None = icons.Rectangle;
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = icons;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/@wikipathways/pvjs/lib/icons/main.js
// module id = 480
// module chunks = 0